import React, { ChangeEvent, useEffect, useState } from 'react';
import { useDebounce } from '@hooks';
import { TextArea } from '@components/Common';
import { DebouncedTextAreaProps } from './DebouncedTextArea.types';

const DebouncedTextArea = ({
  value,
  delay,
  placeholder,
  icon,
  inputSize,
  onSearch,
  className,
}: DebouncedTextAreaProps) => {
  const [currentValue, setCurrentValue] = useState(value);
  const [isSearching, setIsSearching] = useState(false);
  const debouncedValue = useDebounce(currentValue, delay);

  const onTextValueChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    setIsSearching(true);
    setCurrentValue(target.value);
  };

  useEffect(() => {
    if (isSearching) {
      onSearch?.(debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);

  return (
    <TextArea
      className={className}
      defaultValue={currentValue}
      iconLeft={icon}
      inputSize={inputSize}
      placeholder={placeholder}
      onChange={onTextValueChange}
    />
  );
};

DebouncedTextArea.displayName = 'DebouncedTextArea';
export default DebouncedTextArea;
